import { Component, OnDestroy } from '@angular/core';
import { BehaviorSubject, from, of, Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { StreamService } from '../services/stream.service';
import { takeUntil, filter, flatMap, tap, map, concatMap } from 'rxjs/operators';

@Component({
    styles: [`
        .cdk-column-actions.mat-column-actions {
            width: 70px;
        }
    `],
    template: `
        <mat-card>
            <mat-card-content>
                <div *ngIf="noTouching" fxFlex fxLayoutAlign="center center"><spinner></spinner></div>
                <div *ngIf="noResults" fxLayoutALign="center center">
                    <h3>This source is not included in any topics.</h3>
                </div>
                <table mat-table *ngIf="!noTouching && !noResults" [dataSource]="topics" style="width: 100%;">
                    <ng-container matColumnDef="title">
                        <td mat-cell *matCellDef="let row">{{row.title}}</td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                            <td mat-cell *matCellDef="let row">
                                <a [routerLink]="['/topics', row.id, 'content', 'sources']">Edit</a> / <a [routerLink]="['/digest', 'categories', 'unknown', 'topics', row.id]">Read</a>
                            </td>
                        </ng-container>
                    <tr mat-row *matRowDef="let row; columns: ['title', 'actions'];"></tr>
                </table>
            </mat-card-content>
        </mat-card>
    `
})
export class SourceTopicsComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    noTouching: boolean;
    params = new BehaviorSubject<any>({ page: 0, rows: 50 });
    topics = new BehaviorSubject<any[]>([]);
    topicId: any;
    noResults: boolean;
    lastFetched: boolean;

    constructor(route: ActivatedRoute, private streamService: StreamService) {
        route.parent.params 
        .pipe(
            takeUntil(this.cleanupTime),
            filter(params => !!params.topicId),
        )
        .subscribe(params => {
            this.topicId = params.topicId;
            const searchParams = this.params.value;
            searchParams.streamId = this.topicId;
            this.params.next(searchParams);
        });

        this.params
        .pipe(
            tap(() => this.lastFetched = false),
            flatMap(() => from(Array.from({ length: 20 }, (v,k) => k))), // page of 50 and 20 possible goes = 1000
            concatMap(page => this.lastFetched ?
                of({ ignore: true }) :
                streamService.getSourceTopics(this.params.value.streamId, Object.assign({}, this.params.value, { page }))), 
            filter(response => !response.ignore),
            tap(response => this.lastFetched = response.last),
            tap(response => this.noResults = response.last && response.first && response.numberOfElements === 0),
            map(response => response.content),
            takeUntil(this.cleanupTime),
        ).subscribe(topics => this.topics.next(this.topics.value.concat(topics)));
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}